import { useParams } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { useI18n } from "@/i18n/I18nContext";
import { Seo } from "@/components/Seo";

const CONTENT = {
  cgv: {
    es: { title: "Términos y condiciones", body: "Estas son condiciones de demostración. El estudio definirá sus condiciones oficiales de venta, validez de packs y políticas de reembolso." },
    en: { title: "Terms & conditions", body: "These are demo terms. The studio will define its official sales terms, pack validity and refund policies." },
    fr: { title: "Conditions générales", body: "Conditions de démonstration. Le studio définira ses conditions officielles de vente, la validité des packs et les politiques de remboursement." },
  },
  privacy: {
    es: { title: "Política de privacidad", body: "Protegemos tus datos personales y de salud. Solo el personal autorizado accede a la información sensible. Puedes solicitar la exportación o eliminación de tus datos." },
    en: { title: "Privacy policy", body: "We protect your personal and health data. Only authorized staff access sensitive information. You may request export or deletion of your data." },
    fr: { title: "Politique de confidentialité", body: "Nous protégeons tes données personnelles et de santé. Seul le personnel autorisé accède aux informations sensibles. Tu peux demander l'export ou la suppression de tes données." },
  },
  mentions: {
    es: { title: "Aviso legal", body: "Frenchies Fitness & Pilates, Panamá. Contenido de demostración." },
    en: { title: "Legal notice", body: "Frenchies Fitness & Pilates, Panama. Demo content." },
    fr: { title: "Mentions légales", body: "Frenchies Fitness & Pilates, Panama. Contenu de démonstration." },
  },
};

export default function Legal() {
  const { slug } = useParams();
  const { lang } = useI18n();
  const doc = (CONTENT[slug] || CONTENT.cgv)[lang] || (CONTENT[slug] || CONTENT.cgv).es;
  return (
    <PublicLayout>
      <Seo title={`${doc.title} — Frenchies Fitness & Pilates`} description={doc.title} path={`/legal/${slug || "cgv"}`} />
      <section className="mx-auto max-w-3xl px-5 py-12 lg:px-8">
        <h1 className="mb-6 font-display text-4xl font-bold tracking-tight">{doc.title}</h1>
        <p className="leading-relaxed text-muted-foreground">{doc.body}</p>
      </section>
    </PublicLayout>
  );
}
